module.exports = {
  ...require(`../../firebase-config.production`),
  appId: '1:104679062824:web:23803607a8a17984',
  measurementId: 'G-P4F6VP7ZPX',
};
